import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
import SearchBar from "./searchBar";
import { useEffect, useState } from "react";
import { ref, push, onValue, remove, update } from "firebase/database";
import { database } from "./firebase";
import DataTable from "react-data-table-component";
import TableStyleCard from "./tableStyleCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisH,
  faFileEdit,
  faTrash,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";

const Departments = () => {
  const [showModal, setShowModal] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [newDepartment, setNewDepartment] = useState("");
  const [editId, setEditId] = useState(null);

  // Add or update department
  const setDepartment = async (e) => {
    e.preventDefault();
    if (!newDepartment.trim()) return;

    try {
      if (editId) {
        const deptRef = ref(database, `/helpdesk/departments/${editId}`);
        await update(deptRef, { name: newDepartment });
        setEditId(null);
      } else {
        await push(ref(database, "/helpdesk/departments"), {
          name: newDepartment,
          createdAt: new Date().toISOString(),
        });
      }

      setNewDepartment("");
      setShowModal(false);
    } catch (error) {
      console.error("Error saving department:", error);
    }
  };

  // Listen for realtime changes
  useEffect(() => {
    const deptRef = ref(database, "/helpdesk/departments");
    const unsubscribe = onValue(deptRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const deptList = Object.entries(data).map(([id, value]) => ({
          id,
          ...value,
        }));
        setDepartments(deptList);
      } else {
        setDepartments([]);
      }
    });

    return () => unsubscribe();
  }, []);

  // Delete department
  const deleteDepartment = async (id) => {
    try {
      await remove(ref(database, `/helpdesk/departments/${id}`));
    } catch (error) {
      console.error("Error deleting department:", error);
    }
  };

  // Start edit mode
  const startEdit = (dept) => {
    setEditId(dept.id);
    setNewDepartment(dept.name);
    setShowModal(true);
  };

  // Search input handler
  const handleSearch = (term) => {
    setSearchTerm(term.toLowerCase());
  };

  // ✅ Filter departments by search term
  const filteredDepartments = departments.filter((dept) =>
    dept.name?.toLowerCase().includes(searchTerm)
  );

  // Table columns
  const columns = [
    {
      name: "Name",
      cell: (row) => <span className="py-2 h6 text-gray-800">{row.name}</span>,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="dropdown">
          <button
            className="btn btn-round shadow-sm"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <FontAwesomeIcon icon={faEllipsisH} />
          </button>

          <div className="dropdown-menu dropdown-menu-right border-0 shadow-lg">
            <button className="dropdown-item" onClick={() => startEdit(row)}>
              <FontAwesomeIcon className="text-gray-300" icon={faFileEdit} />
              Edit
            </button>
            <div className="dropdown-divider"></div>
            <button
              className="dropdown-item text-danger"
              onClick={() => deleteDepartment(row.id)}
            >
              <FontAwesomeIcon className="text-gray-3000" icon={faTrash} />
              Delete
            </button>
          </div>
        </div>
      ),
      width: "80px",
    },
  ];

  return (
    <>
      <div className="card mt-4 shadow">
        <div className="card-header bg-white py-2 d-flex align-items-center">
          <div className="d-flex w-100">
            <SearchBar onSearch={handleSearch} />

            <button
              className="btn btn-lg btn-primary ml-auto"
              onClick={() => {
                setEditId(null);
                setShowModal(true);
              }}
            >
              Add
            </button>
          </div>
        </div>
      </div>

      <div className="p-2" style={{ background: "#E1E3F0" }}>
        <DataTable
          customStyles={TableStyleCard}
          columns={columns}
          data={filteredDepartments}
          pagination
          noTableHead
          highlightOnHover
          dense
        />
      </div>

      {/* Modal */}
      <Modal show={showModal}>
        <ModalHeader>
          <ModalTitle>
            {editId ? "Edit Department" : "Add Department"}
          </ModalTitle>
          <button className="btn btn-round" onClick={() => setShowModal(false)}>
            <span className="material-icons">close</span>
          </button>
        </ModalHeader>

        <ModalBody>
          <form onSubmit={setDepartment}>
            <input
              className="form-control"
              name="name"
              placeholder="Enter name of department"
              value={newDepartment}
              onChange={(e) => setNewDepartment(e.target.value)}
              required
            />
          </form>
        </ModalBody>

        <ModalFooter>
          <button className="btn btn-primary" onClick={setDepartment}>
            {editId ? "Update" : "Submit"}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Departments;
